import React from 'react';
import { Shield, Lock, Phone, Mail } from 'lucide-react';
export function SimonsHeader({
  activePage,
  setActivePage
}: {
  activePage: string;
  setActivePage: (p: any) => void;
}) {
  return <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-100 px-6 py-4" data-id="element-55">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-56">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => setActivePage('home')} data-id="element-57">
          <div className="w-10 h-10 bg-[#002366] rounded-lg flex items-center justify-center text-[#FFD700] shadow-lg" data-id="element-58">
            <Shield size={24} fill="currentColor" data-id="element-59" />
          </div>
          <span className="text-xl font-black tracking-tight uppercase text-[#002366]" data-id="element-60">
            Simons <span className="text-[#DC143C]" data-id="element-61">Acquah</span>
          </span>
        </div>

        <div className="hidden lg:flex items-center gap-8 text-sm font-bold uppercase tracking-wider text-[#002366]" data-id="element-62">
          <button onClick={() => setActivePage('commercial')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'commercial' ? 'text-[#DC143C]' : ''}`} data-id="element-63">
            Commercial
          </button>
          <button onClick={() => setActivePage('landlord')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'landlord' ? 'text-[#DC143C]' : ''}`} data-id="element-64">
            Landlord
          </button>
          <button onClick={() => setActivePage('trucking')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'trucking' ? 'text-[#DC143C]' : ''}`} data-id="element-65">
            Trucking
          </button>
          <button onClick={() => setActivePage('personal')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'personal' ? 'text-[#DC143C]' : ''}`} data-id="element-66">
            Personal
          </button>
        </div>

        <div className="flex items-center gap-4" data-id="element-67">
          <button onClick={() => setActivePage('portal')} className="hidden sm:block px-5 py-2 bg-[#FFD700] text-[#002366] rounded-lg text-xs font-black uppercase tracking-widest hover:shadow-lg transition-all" data-id="element-68">
            Client Portal Login
          </button>
          <button className="px-5 py-2 bg-[#DC143C] text-white rounded-lg text-xs font-bold uppercase tracking-widest hover:bg-[#B21031] transition-all shadow-lg shadow-[#DC143C]/20" data-id="element-69">
            Request Quote
          </button>
        </div>
      </div>
    </nav>;
}
export function SimonsFooter() {
  return <footer className="bg-[#002366] text-white pt-20 pb-10 px-6" data-id="element-70">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-71">
        <div className="col-span-1 md:col-span-1" data-id="element-72">
          <div className="flex items-center gap-3 mb-6" data-id="element-73">
            <div className="w-8 h-8 bg-white rounded flex items-center justify-center text-[#002366]" data-id="element-74">
              <Shield size={18} fill="currentColor" data-id="element-75" />
            </div>
            <span className="text-lg font-black tracking-tight uppercase" data-id="element-76">
              Simons <span className="text-[#DC143C]" data-id="element-77">Acquah</span>
            </span>
          </div>
          <p className="text-white/60 text-sm font-medium leading-relaxed" data-id="element-78">
            Strategic insurance solutions for the modern era. We protect your
            assets with precision and expertise.
          </p>
        </div>

        <div data-id="element-79">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-80">
            Solutions
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-81">
            <li data-id="element-82">
              <a href="#" className="hover:text-white transition-colors" data-id="element-83">
                Commercial Auto
              </a>
            </li>
            <li data-id="element-84">
              <a href="#" className="hover:text-white transition-colors" data-id="element-85">
                Landlord Protection
              </a>
            </li>
            <li data-id="element-86">
              <a href="#" className="hover:text-white transition-colors" data-id="element-87">
                Cargo Insurance
              </a>
            </li>
            <li data-id="element-88">
              <a href="#" className="hover:text-white transition-colors" data-id="element-89">
                Personal Bundles
              </a>
            </li>
          </ul>
        </div>

        <div data-id="element-90">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-91">
            Contact
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-92">
            <li className="flex items-center gap-2" data-id="element-93">
              <Phone size={14} data-id="element-94" /> (555) 123-4567
            </li>
            <li className="flex items-center gap-2" data-id="element-95">
              <Mail size={14} data-id="element-96" /> info@simonsacquah.com
            </li>
            <li data-id="element-97">123 Strategic Way, Suite 100</li>
            <li data-id="element-98">New York, NY 10001</li>
          </ul>
        </div>

        <div data-id="element-99">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-100">
            Resources
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-101">
            <li data-id="element-102">
              <a href="#" className="hover:text-white transition-colors" data-id="element-103">
                Claims Center
              </a>
            </li>
            <li data-id="element-104">
              <a href="#" className="hover:text-white transition-colors" data-id="element-105">
                Risk Blog
              </a>
            </li>
            <li data-id="element-106">
              <a href="#" className="hover:text-white transition-colors" data-id="element-107">
                Privacy Policy
              </a>
            </li>
            <li data-id="element-108">
              <button className="flex items-center gap-2 text-[#FFD700] hover:text-white transition-colors" data-id="element-109">
                <Lock size={14} data-id="element-110" /> Agent Portal Login
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-111">
        <p className="text-[10px] font-bold text-white/40 uppercase tracking-widest" data-id="element-112">
          © 2026 Simons Acquah Agency. All rights reserved.
        </p>
        <div className="flex gap-6" data-id="element-113">
          <div className="w-5 h-5 bg-white/10 rounded-full" data-id="element-114"></div>
          <div className="w-5 h-5 bg-white/10 rounded-full" data-id="element-115"></div>
          <div className="w-5 h-5 bg-white/10 rounded-full" data-id="element-116"></div>
        </div>
      </div>
    </footer>;
}